import { PM_DIAL } from "app/_constants/pure-cloud"

export class PureCloudPMModel{
    type :string = PM_DIAL; 
    number : string = '';
    address:string = '';
    autoPlace: boolean = true;
    queueId:string = '';
    attributes: {}
}